import React, { useState } from 'react';
import { MenuItem, Select } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import clsx from 'clsx';
import style from './style.module.scss';

const Block = ({ id, name, label, required, placeholder, options, errors }) => {
    const [value, setValue] = useState('');

    const err = errors.filter((el) => el.field === name);

    return (
        <div className={style.block}>
            <label className={clsx(style.label, required && style.required)} htmlFor={id}>
                {label}
            </label>

            <Select
                id={id}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                IconComponent={ExpandMore}
                className={style.select}
                displayEmpty
                name={name}
                required={required ?? false}
                aria-invalid={(err && err.length > 0) || (required && value.length === 0)}
                renderValue={(selected) => {
                    if (selected.length === 0) {
                        return <em>{placeholder}</em>;
                    }
                    return options.find((option) => option.value === selected).label;
                }}
            >
                {options &&
                    options.length > 0 &&
                    options.map((el, i) => {
                        return (
                            <MenuItem value={el.value} key={i} className={style.item}>
                                {el.label}
                            </MenuItem>
                        );
                    })}
            </Select>
            {err && err.length ? <div className={style.error}>{err[0].message}</div> : <></>}
        </div>
    );
};

export default Block;
